<template>
	<div>
		<common-tab :list="[{ title: '融资介绍', name: '1' },{ title: '融资详情文件', name: '2' }]"></common-tab>
		<div id="finance" v-show="tabId == 1">
			<div class="content">
				<div v-html="content"></div>
			</div>

			<div id="btn-container">
				<van-button id="btn-apply" type="info" :to="{ path: '/finance/applying' }" :disabled="token == ''">我要融资</van-button>
			</div>
		</div>
		<div v-show="tabId == 2">
			<financefile :tabId="tabId"></financefile>
		</div>
	</div>
</template>

<script>
import File from './File.vue'
import CommonTab from '@/components/CommonTab.vue'
import { mapGetters } from 'vuex'

export default {
	components: {
		commonTab: CommonTab,
		financefile: File,
	},
	data() {
		return {
			content: '',
			tabId: 1,
		}
	},
	computed: {
		...mapGetters(['token', 'userId', 'communityId']),
	},
	watch: {
		communityId() {
			this.getData()
		},
	},

	methods: {
		getData() {
			this.vaxios.get(
				`${this.vaxios.host}/open/api/v1/investment-finances/status/published`,
				{
					communityId: this.communityId,
				},
				(res) => {
					this.content = res.data.content
				},
				function(err) {
					console.log(err)
				}
			)
		},
	},
	created() {
		this.communityId.length > 0 && this.getData()
	},
}
</script>

<style scoped>
#finance {
	background-color: #f5f5f5;
	padding-top: 0.75rem;
}

.content {
	padding: 0.325rem 0.75rem;
	background-color: #ffffff;
}

#btn-container {
	position: fixed;
	margin-top: 3.3125rem;
	bottom: 0;
	width: 100%;
	z-index: 99;
	background: white;
	height: 80px;
	text-align: center;
	display: flex;
	align-items: center;
	border-top: 0.5px solid lightgray;
}

#btn-apply {
	width: 91.47%;
	font-size: 1.125rem;
	height: 2.75rem;
	padding: 0;
	margin: 0 auto;
}

.content {
	margin-bottom: 100px;
	background: white;
}
</style>
